"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.Span = exports.Label = exports.Container = exports.Wrapper = exports.StyledTextArea = exports.StyledInput = void 0;
const tslib_1 = require("tslib");
const __1 = require("..");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.StyledInput = styled_components_1.default.input `
  color: #000;
  width: 100%;
  height: 75px;
  outline: none;
  font-size: 15px;
  padding: 20px 30px;
  border-radius: 6px;
  position: relative;
  border: ${({ invalid }) => invalid ? `2px solid #E33610` : `0.5px solid #b7bec6`};

  &:not(:placeholder-shown) {
    padding-top: 40px;
  }

  &:not(:placeholder-shown) + label {
    transform: translateY(-15px);
    font-size: 12px;
  }

  &:focus {
    padding-top: 40px;
    border: ${({ invalid }) => invalid ? `2px solid #E33610` : `2px solid #337ACE`};
  }

  &:focus + label {
    transform: translateY(-15px);
    font-size: 12px;
  }
`;
exports.StyledTextArea = styled_components_1.default.textarea `
  color: #000;
  width: 100%;
  height: 75px;
  outline: none;
  font-size: 15px;
  padding: 20px 30px;
  border-radius: 6px;
  position: relative;
  border: ${({ invalid }) => invalid ? `2px solid #E33610` : `0.5px solid #b7bec6`};

  &:not(:placeholder-shown) {
    padding-top: 40px;
  }

  &:not(:placeholder-shown) + label {
    transform: translateY(-15px);
    font-size: 12px;
  }

  &:focus {
    padding-top: 40px;
    border: ${({ invalid }) => invalid ? `2px solid #E33610` : `2px solid #337ACE`};
  }

  &:focus + label {
    transform: translateY(-15px);
    font-size: 12px;
  }
`;
exports.Wrapper = styled_components_1.default.div `
  width: 100%;
  position: relative;
  display: inline-block;
`;
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;
`;
exports.Label = styled_components_1.default.label `
  top: 50%;
  left: 30px;
  color: #9fa8b3;
  font-size: 15px;
  font-weight: 500;
  position: absolute;
  pointer-events: none;
  transform: translateY(-50%);
  transition: transform 100ms ease;
`;
exports.Span = styled_components_1.default.span `
  color: #e12900;
  font-size: 15px;
  font-weight: 500;
  padding: 12px 0;
`;
exports.StyledIcon = (0, styled_components_1.default)(__1.Icon) `
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
`;
